<div class="select-container" [ngClass]="{'--theme-unico' : theme === 'unico'}" (mouseleave)="open = false">
  <div #buttonFilter class="select-container__title" [ngClass]="{'--open' : open}" (click)="openFilter($event)">
      <p>{{title}}</p>
  </div>
  <div *ngIf="filter$ | async as filter" class="select-container__list" [ngClass]="{'--open' : open}">
    <div class="select-container__input">
      <form [formGroup]="filterSearch">
        <input formControlName="search" type="search" placeholder="Pesquisar" attr.data-test="searchFilter{{title}}">
      </form>
    </div>
    <ul infiniteScroll [infiniteScrollDisabled]="isSearch" [infiniteScrollDistance]="2" [scrollWindow]="false" (scrolled)="onScroll()" class="select-container__list__container">
      <ng-container *ngIf="filter.length && open; else noItems;">
        <li *ngFor="let item of filter; trackBy: trackByIdx">
          <div class="field-holder-modal field-checkbox field-checkbox-steps">
            <span>
              <input id="{{item.uid}}" type="checkbox" [attr.data-uid]="item.uid" (change)="selectedFilter($event.target)">
              <label for="{{item.uid}}">{{item.name}}</label>
              <span class="check-box"></span>
            </span>
          </div>
        </li>
      </ng-container>
      <ng-template #noItems>
        <span class="select-container__no-results">Nenhum Resultado</span>
      </ng-template>
    </ul>
  </div>
</div>
